var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{style:({
    minHeight: '100vh'
  })},[_c('a-layout-header',{staticClass:"app-layout-header primary-blue-bg",style:({
            position: 'fixed',
            top: 0,
            zIndex: 100,
            width: '100%',
        })},[_c('AppHeaderComponent')],1),_c('a-layout-content',{staticClass:"app-layout-content",style:({
            marginTop: '75px',
            height: 'calc(100vh - 75px - 70px)',
            marginBottom: '70px',
            overflowY: 'scroll'
        })},[_c('FadeTransition',[_c('router-view')],1)],1),_c('a-layout-footer',{style:({
            borderTop: '1px solid #e8e8e8',
            position: 'fixed',
            zIndex: 100,
            bottom: 0,
            width: '100%',
        })},[_c('AppFooterComponent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }